<template>
  <b-modal
    ref="modalConfirm"
    dialog-class="!max-w-[600px] !w-full"
    body-class="!p-[28px]"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <div>
      <img
        :src="icon"
        class="size-[98px] mx-auto my-[20px]"
      >
      <div>
        <h3 class="text-center text-[24px] font-semibold text-[#333333] mb-[18px]">
          {{ title }}
        </h3>
        <p class="text-center text-[16px] !text-[#626262] mb-[24px]">
          {{ description }}
        </p>
      </div>
      <div class="flex gap-[8px] justify-center">
        <b-button
          :variant="type === 'success' ? 'primary' : 'outline-primary'"
          class="w-full"
          @click="close"
        >
          {{ type === 'success' ? 'Selesai' : 'Batal' }}
        </b-button>
        <b-button
          v-if="type === 'confirm'"
          variant="primary"
          class="w-full !flex items-center justify-center gap-[8px]"
          :disabled="isLoading"
          @click="confirm"
        >
          <b-spinner
            v-if="isLoading"
            small
          />
          <span>
            Konfirmasi
          </span>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalConfirm',
  data() {
    return {
      title: '',
      description: '',
      type: 'success',
      isLoading: false,
    }
  },
  computed: {
    icon() {
      return this.type === 'success'
        ? 'https://storage.googleapis.com/komerce/assets/icons/success.svg'
        : 'https://storage.googleapis.com/komerce/assets/icons/warning.svg'
    },
  },
  created() {
    this.confirmFn = () => {}
  },
  methods: {
    /**
     * @param {Object} options - { title, description, type, confirmFn }
     */
    show(options) {
      this.title = options.title
      this.description = options.description
      this.type = options.type
      this.confirmFn = options.confirmFn
      this.$refs.modalConfirm.show()
    },
    close() {
      this.$refs.modalConfirm.hide()
    },
    async confirm() {
      this.isLoading = true
      await this.confirmFn(this.close)
      this.isLoading = false
    },
  },
}
</script>
